var _path, _g, _path2, _path3, _path4, _g2, _path5, _path6, _path7, _g3, _path8, _path9, _path0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptystateuser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 141,
    viewBox: "0 0 200 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162 0H42C36.4772 0 32 4.47715 32 10V130C32 135.523 36.4772 140 42 140H162C167.523 140 172 135.523 172 130V10C172 4.47715 167.523 0 162 0Z",
    fill: "url(#paint0_linear_1562_15717)",
    fillOpacity: 0.32
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1562_15717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54 54H189C190.326 54 191.598 54.5268 192.536 55.4645C193.473 56.4021 194 57.6739 194 59V84C194 85.3261 193.473 86.5979 192.536 87.5355C191.598 88.4732 190.326 89 189 89H54C52.6739 89 51.4021 88.4732 50.4645 87.5355C49.5268 86.5979 49 85.3261 49 84V59C49 57.6739 49.5268 56.4021 50.4645 55.4645C51.4021 54.5268 52.6739 54 54 54Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128 62H102C100.343 62 99 63.3431 99 65C99 66.6569 100.343 68 102 68H128C129.657 68 131 66.6569 131 65C131 63.3431 129.657 62 128 62Z",
    fill: "#01549C",
    fillOpacity: 0.32
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M146 75H102C100.343 75 99 76.3431 99 78C99 79.6569 100.343 81 102 81H146C147.657 81 149 79.6569 149 78C149 76.3431 147.657 75 146 75Z",
    fill: "#AEC8DF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 81C71.7467 81 76 76.7467 76 71.5C76 66.2533 71.7467 62 66.5 62C61.2533 62 57 66.2533 57 71.5C57 76.7467 61.2533 81 66.5 81Z",
    fill: "#00539B",
    fillOpacity: 0.32
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1562_15717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 97H146C147.326 97 148.598 97.5268 149.536 98.4645C150.473 99.4021 151 100.674 151 102V127C151 128.326 150.473 129.598 149.536 130.536C148.598 131.473 147.326 132 146 132H11C9.67392 132 8.40215 131.473 7.46447 130.536C6.52678 129.598 6 128.326 6 127V102C6 100.674 6.52678 99.4021 7.46447 98.4645C8.40215 97.5268 9.67392 97 11 97V97Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85 105H59C57.3431 105 56 106.343 56 108C56 109.657 57.3431 111 59 111H85C86.6569 111 88 109.657 88 108C88 106.343 86.6569 105 85 105Z",
    fill: "#01549C",
    fillOpacity: 0.32
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103 118H59C57.3431 118 56 119.343 56 121C56 122.657 57.3431 124 59 124H103C104.657 124 106 122.657 106 121C106 119.343 104.657 118 103 118Z",
    fill: "#AEC8DF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 124C28.7467 124 33 119.747 33 114.5C33 109.253 28.7467 105 23.5 105C18.2533 105 14 109.253 14 114.5C14 119.747 18.2533 124 23.5 124Z",
    fill: "#00539B",
    fillOpacity: 0.32
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1562_15717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146 11H11C8.23858 11 6 13.2386 6 16V41C6 43.7614 8.23858 46 11 46H146C148.761 46 151 43.7614 151 41V16C151 13.2386 148.761 11 146 11Z",
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83 19H57C55.3431 19 54 20.3431 54 22C54 23.6569 55.3431 25 57 25H83C84.6569 25 86 23.6569 86 22C86 20.3431 84.6569 19 83 19Z",
    fill: "#00539B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M101 32H57C55.3431 32 54 33.3431 54 35C54 36.6569 55.3431 38 57 38H101C102.657 38 104 36.6569 104 35C104 33.3431 102.657 32 101 32Z",
    fill: "#00539B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 38C41.7467 38 46 33.7467 46 28.5C46 23.2533 41.7467 19 36.5 19C31.2533 19 27 23.2533 27 28.5C27 33.7467 31.2533 38 36.5 38Z",
    fill: "#00539B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1562_15717",
    x: 43,
    y: 51,
    width: 157,
    height: 47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1562_15717"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1562_15717",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1562_15717",
    x: 0,
    y: 94,
    width: 157,
    height: 47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1562_15717"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1562_15717",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1562_15717",
    x: 0,
    y: 8,
    width: 157,
    height: 47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1562_15717"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1562_15717",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1562_15717",
    x1: 102,
    y1: 0,
    x2: 102,
    y2: 140,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#00539B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptystateuser);
export default __webpack_public_path__ + "static/media/emptystateuser.75b63f4553edf8e02babb57049bef1f9.svg";
export { ForwardRef as ReactComponent };